import { MS_PER_MINUTE, MS_PER_HOUR, MS_PER_DAY } from './constants.js';

/**
 * Format date to relative time string (short format)
 * Examples: "5m ago", "2h ago", "Yesterday", "3 days ago", "Oct 15"
 * @param {string} dateString - ISO date string
 * @returns {string} - Formatted relative time
 */
export const formatRelativeTime = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now - date);
  const diffDays = Math.floor(diffTime / MS_PER_DAY);

  if (diffDays === 0) {
    const diffHours = Math.floor(diffTime / MS_PER_HOUR);
    if (diffHours === 0) {
      const diffMins = Math.floor(diffTime / MS_PER_MINUTE);
      return `${diffMins}m ago`;
    }
    return `${diffHours}h ago`;
  } else if (diffDays === 1) {
    return 'Yesterday';
  } else if (diffDays < 7) {
    return `${diffDays} days ago`;
  } else {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
};

/**
 * Format date to "Last edited" format (longer format)
 * Examples: "Last edited 5 minutes ago", "Last edited Oct 15, 2022"
 * @param {string} dateString - ISO date string
 * @returns {string} - Formatted string with "Last edited" prefix
 */
export const formatLastEdited = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now - date);
  const diffHours = Math.floor(diffTime / MS_PER_HOUR);

  if (diffHours < 1) {
    const diffMins = Math.floor(diffTime / MS_PER_MINUTE);
    return `Last edited ${diffMins} minutes ago`;
  } else if (diffHours < 24) {
    return `Last edited ${diffHours} hours ago`;
  } else {
    return `Last edited ${date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    })}`;
  }
};
